export enum EnrollmentPacketSaveAction {
  SAVE = 'Save',
  ACCEPTED = 'Accepted',
  MISSING_INFO = 'Missing Info',
  AGE_ISSUE = 'Age Issue',
  CONDITIONAL = 'Conditional',
  STARTED = 'Started',
  NOT_STARTED = 'Not Started',
}
